// extracted by mini-css-extract-plugin
export var productImage = "_op-1";
export var viewLink = "_op-2";
export var wishlistItem = "_op-0";